export default {
  dialogTitle: "修改案件",
  caseName: {
    label: "案件名称",
    placeholder: "请输入案件名称(必填)",
  },
  caseType: {
    label: "案件类型",
    placeholder: "请选择案件类型",
  },
  caseDescription: {
    label: "案件说明",
    placeholder: "请输入案件说明",
  },
  buttons: {
    reset: "重置",
    confirm: "确认",
  },
  messages: {
    editSuccess: "修改成功",
  },
  validation: {
    caseNameRequired: "案件名称为必填项",
    caseNameLength: "长度在 1 到 20个字符",
    caseTypeRequired: "请选择案件类型",
    caseDescriptionLength: "长度在 1 到 200个字符",
  },
};
